module.exports = __webpack_public_path__ + "media/bathrooms.d9d747a0.svg";